import { apiPost } from "../../utils"

export function adminLoginAPI(data) {
    return apiPost('/api/adminlogin', data)
}
